import React from 'react';
import { createRoot } from 'react-dom/client';
import './assets/scss/app.scss';
import App from './App';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SesionContexto, { SesionProvider } from './context/ContextoSesion';

const container = document.getElementById('root');
const root = createRoot(container); // Creamos la raíz

root.render(
	<React.StrictMode>
		<BrowserRouter>
			<SesionProvider>
				<Routes>
					<Route path="/*" element={<App />} />
				</Routes>
			</SesionProvider>
		</BrowserRouter>
	</React.StrictMode>
);